import { MULTI_TOUR_DISCOUNT_PERCENTAGE } from "mt-shared/multiTourDiscount";
import { CSSProperties, useState } from "react";
import Button from "../../../Atoms/Button";
import { useToast } from "../../../Atoms/Toast";
import AddToCartForm, { type AddToCartProduct } from "./Form/Form";
import styles from "./index.module.scss";
import { tracker } from "../../../../utils/analytics2";

type AddToCartButtonProps = {
  style?: CSSProperties;
  showDiscount?: boolean;
  productId: string;
  product?: AddToCartProduct;
  date?: string | null;
  time?: string | null;
};

export default function AddToCartButton(props: AddToCartButtonProps) {
  const [isOpen, setIsOpen] = useState(false);
  const { showToast } = useToast();

  return (
    <>
      <div className={styles.offer} style={props.style}>
        <div className={styles.buttonContainer}>
          <Button
            className={styles.addButton}
            large
            onClick={() => {
              tracker.trackEvent({
                category: "cart",
                action: "add_to_cart_click",
                label: props.productId,
              });
              setIsOpen(true);
            }}
          >
            Add To Cart
          </Button>
        </div>
        {props.showDiscount && (
          <p className={styles.offerMessage}>
            <strong className={styles.savings}>
              {MULTI_TOUR_DISCOUNT_PERCENTAGE}% discount
            </strong>{" "}
            when booking 2+ tours
          </p>
        )}
      </div>

      {isOpen && (
        <AddToCartForm
          productId={props.productId}
          product={props.product}
          setIsOpen={setIsOpen}
          onAddedToCart={() =>
            showToast({
              message: "Added to cart",
              variant: "success",
              duration: 10000,
              actionLabel: "View cart",
              actionHref: "/cart",
            })
          }
          initialDate={props.date || null}
          initialTime={props.time || null}
        />
      )}
    </>
  );
}
